module.exports = __webpack_public_path__ + "img/8eb244f.jpg";